import { render, staticRenderFns } from "./itemConfig.vue?vue&type=template&id=2b1c3941&"
import script from "./itemConfig.vue?vue&type=script&lang=js&"
export * from "./itemConfig.vue?vue&type=script&lang=js&"
import style0 from "./itemConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports